//Vue imports
import { createRouter, createWebHistory } from "vue-router";

// Our imports
import UserLogin from "@/views/onboarding/Login/UserLogin.vue";
import OneTimePin from "@/views/onboarding/OneTimePin/OneTimePin.vue";
import ForgotPassword from "@/views/onboarding/ForgotPassword/ForgotPassword.vue";
import ResetPassword from "@/views/onboarding/ResetPassword/ResetPassword.vue";
import routes from "@/router/config_routers/routes.js";
import HandleSSOLogin from "@/views/onboarding/Handle_SSO_login/HandleSSOLogin.vue";
import FirstTimeLogin from "@/views/onboarding/first_time_login/FirstTimeLogin.vue";
import { validate_route } from "@/utils/auth/auth.js";
import OrganizationSignup from "@/views/onboarding/OrganizationSignup/OrganizationSignup.vue";

const probaworkflows_routes = routes

const common_routes = [
  // Onboarding
  {
    path: "",
    name: "UserLogin",
    component: UserLogin,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
  },
  {
    path: "/organization/signup",
    name: "OrganizationSignup",
    component: OrganizationSignup,
    meta: { requires_auth: false, requires_otp: false },
  },
  {
    path: "/handle_sso_login/:token?/:user_id?/:user_role?/:is_aic_one_login?/:current_system?/",
    name: "HandleSSOLogin",
    component: HandleSSOLogin,
    meta: { requires_auth: false, requires_otp: false }, // No authentication required for login
    beforeEnter: (to, from, next) => {
      const token = to.params.token;
      const userId = to.params.user_id;

      if (token && userId) {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user_id', userId);
        next();
      } else {
        next('/login');
      }
    }

  },
   
  {
    path: "/one_time_pin",
    name: "OneTimePin",
    component: OneTimePin,
    meta: { requires_otp: false }, // No OTP verification required for one time pin
  },

  {
    path: "/forgot_password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { requires_auth: false, requires_otp: false },
  },

  {
    path: "/reset_password/:link",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { requires_auth: false, requires_otp: false },
    props: true,
  },
  {
    path: "/first_time_login",
    name: "FirstTimeLogin",
    component: FirstTimeLogin,
    meta: { requires_auth: false, requires_otp: false },
  
  }

  


];

const router = createRouter({
  history: createWebHistory(),
  routes: [...probaworkflows_routes, ...common_routes],
});

router.beforeEach((to) => validate_route(router, to));

export default router;
